module.exports = __webpack_public_path__ + "static/img/t12.d42020fb.png";